/**
 * Navigation utility for determining back button behavior
 */

// Track internal navigation
export function trackInternalNavigation(path) {
  sessionStorage.setItem('hasInternalNavigation', 'true');
  sessionStorage.setItem('lastNavigatedPath', path);
}

export function getBackTarget() {
  // Simple: just go back
  return { type: 'history' };
  
  /*
  // TODO: Use hasInternalNavigation flag for future logic
  try {
    const lastInternalRoute = sessionStorage.getItem('lastInternalRoute');
    const currentPath = window.location.pathname;
    
    // Check if referrer is same origin
    let sameOriginReferrer = false;
    if (document.referrer) {
      try {
        sameOriginReferrer = new URL(document.referrer).origin === window.location.origin;
      } catch (error) {
        // Invalid referrer URL, ignore
        sameOriginReferrer = false;
      }
    }
    
    // If we have a valid last internal route that's not current path or login
    if (lastInternalRoute && 
        lastInternalRoute !== currentPath && 
        lastInternalRoute !== '/login') {
      return { type: 'history' };
    }
    
    // If same origin referrer and we have history
    if (sameOriginReferrer && window.history.length > 1) {
      return { type: 'history' };
    }
    
    // Default to home
    return { type: 'home', to: '/' };
  } catch (error) {
    console.warn('Error in getBackTarget:', error);
    return { type: 'home', to: '/' };
  }
  */
}